export interface SalesDespatchItemInvoiceAddRemove {
  salesInvoiceHeaderId: string;
  salesDespatchNoteId: string;
}
